import React, {Fragment, useContext} from 'react';
import {Switch} from 'antd';
import {OrderBlock, Row, Text, Divider} from '../Widgets';
import useCalculations from '../hooks/use-calculation';
import {Context} from '../AppContext';
import QuotationDownload from './QuotationDownload';
import {errorHandler} from '../errors';
const appConfig = require('../data.json');

export default function Calculation(props) {
  const {order, calculations, config, setConfig} = props;
  let {
    items_amount, //商品金額（未稅）
    items_tax, //商品金額（稅）
    discount, //活動折抵（未稅）
    discount_tax, //活動折抵（稅）
    fee, //運費(未稅)
    fee_tax, //運費（稅）
    bonus, //紅利（未稅）
    bonus_tax, //紅利（稅）
    feedback_bonus, //此訂單將會送的紅利
    tax,
    amount, //訂單總計金額(含稅)
  } = useCalculations(calculations);

  return (
    <OrderBlock title="商品總額">
      <Row margin="0 0 15px 0">
        <Text size="sm" style={{flex: 1}}>
          商品金額（含稅）
        </Text>
        <Text size="sm" weight="600">
          $ {items_amount + items_tax}
        </Text>
      </Row>

      <Row margin="0 0 15px 0">
        <Text size="sm" style={{flex: 1}}>
          紅利折抵（含稅）
        </Text>
        <Text
          size="sm"
          weight="600"
          color={bonus !== 0 ? appConfig.colors.error : null}>
          $ {bonus + bonus_tax}
        </Text>
      </Row>

      <Row margin="0 0 15px 0">
        <Text size="sm" style={{flex: 1}}>
          活動折抵（含稅）
        </Text>
        <Text
          size="sm"
          weight="600"
          color={discount !== 0 ? appConfig.colors.error : null}>
          {' '}
          {`$ ${discount + discount_tax}`}{' '}
        </Text>
      </Row>

      <Row margin="0 0 15px 0">
        <Text size="sm" style={{flex: 1}}>
          運費（含稅）
        </Text>
        <Text size="sm" weight="600">
          ${fee + fee_tax}
        </Text>
      </Row>

      {/* <Row margin="0 0 15px 0">
        <Text size="sm" style={{flex: 1}}>
          營業稅
        </Text>
        <Text size="sm" weight="600">
          $ {tax}
        </Text>
      </Row> */}
      {!order && !appConfig.isLiteVersion && (
        <BonusCheckBox
          calculations={calculations}
          config={config}
          setConfig={setConfig}
        />
      )}

      <Row>
        <Text size="sm" style={{flex: 1}}>
          訂單總計金額（含稅）
        </Text>
        <Text
          weight="600"
          color={appConfig.colors.error}
          style={{fontSize: 24}}>
          $ {amount}
        </Text>
      </Row>
      <Row style={{justifyContent: 'flex-end'}}>
        <Text size="sm" style={{opacity: 0.8}}>
          本訂單可獲得紅利金
        </Text>
        <Text size="sm" color={appConfig.colors.main}>
          {feedback_bonus}
        </Text>
        <Text size="sm" style={{opacity: 0.8}}>
          元
        </Text>
      </Row>

      <QuotationDownload order={order} />
      {/* {order && <PdfDownloadButton order={order} />} */}
    </OrderBlock>
  );
}

function BonusCheckBox({calculations, config, setConfig}) {
  /*
  訂單滿100元即可使用紅利, 最低折到15元 （發票問題）
  只能折訂單30％
  profile.bonus > 0
  */

  const app = useContext(Context);
  const {profile, cart} = app.state;
  const bonusTotal = calculations.bonus + calculations.bonus_tax;
  const isPeriod = cart.items.find((item) => item.is_period);

  if (!cart) {
    return null;
  }
  if (isPeriod) {
    return null;
  }

  if (
    calculations.items_amount + calculations.items_tax > 100 &&
    profile.bonus > 0
  ) {
    return (
      <Fragment>
        <Divider />
        <Row>
          <Text size="xs">目前紅利金總餘額 {profile.bonus} 點</Text>
        </Row>
        <Row>
          <Switch
            checked={config.use_bonus}
            onChange={(checked) => {
              if (checked) {
                alert(
                  '一旦建立訂單(第三步，選付款方式)將會扣除紅利點數，若七天內未前往付款、取消訂單、售後退款，紅利點數仍會被扣除。',
                );
              }
              setConfig({...config, use_bonus: checked});
            }}
            style={{marginRight: 5}}
          />
          <Text size="xs">
            使用紅利金折抵{bonusTotal ? bonusTotal + '點' : ''}{' '}
            (最高可折抵訂單30%)
          </Text>
        </Row>
        <Divider />
      </Fragment>
    );
  }
  return null;
}
